// extracted by mini-css-extract-plugin
export default {"primaryColor":"#005980","primaryColorWithAlpha":"rgba(0,89,128,.1019607843)","mainBgColor":"#fff","secondBgColor":"#efefef","yellowColor":"#fae100"};